// The site's own calls, which every page makes, signed in or not, through the doorway (doorway.ts): the notice
// (ai_app_backend plan.pm, site-notice). With the `site_notice` area's switch off it sends exactly the request
// SiteNotice.jsx sent before (tests/site-api.test.mjs); on v2 it is v2's `GET /v2/notice`, which answers v1's shape,
// `{ notice }`, asked without a sign-in, as it is the same for everyone.
import { call, lazySide } from './doorway.ts'

/**
 * The site's notice, `{ notice }`: one line every page shows while part of the site is paused, or null. `token` is the
 * person's Firebase ID token, or '' signed out: it only places them in the switch's group.
 */
export const siteNotice = (token: string) =>
  call(
    'site_notice',
    '/api/site_notice',
    {},
    {
      token,
      side: lazySide(
        () => import('./v2.ts'),
        ({ answer, v2SignedOut }) =>
          async (_t, init) => {
            const { data, error, response } = await v2SignedOut().GET(
              '/v2/notice',
              { ...(init.signal ? { signal: init.signal } : {}) },
            )
            return answer(response.status, data ?? error ?? {})
          },
        '/api/site_notice',
      ),
    },
  )
